import apiOrg from '@/apps/org/api/orgstructure'

// Идентификаторы сущностей для массовой загрузки
let _posts_ids = []
let _containers_ids = []

//Загрузка информации об постах и контейнерах
const loadEntities = commit => {
  let requestData = {
    posts_ids: _posts_ids || [],
    containers_ids: _containers_ids || []
  }

  // Обнуляем ID для загрузки ( возможно перенести в THEN)
  _containers_ids = []
  _posts_ids = []

  // Оправляем запрос на получение данных
  apiOrg.entitiesInfo(requestData).then(
    data => {
      commit('addPosts', data.posts_data || [])
      commit('addContainers', data.containers_data || [])
    },
    error => {
      console.warn(error)
    }
  )
}

// Гарантированный вызов 'loadEntities' раз в секунду с устранением дребезга
const debouncedLoadEntities = _.debounce(loadEntities, 250, { maxWait: 1000 })

export default {
  //Получение полной информации о посте или контейнере
  loadEntity: ({ commit }, { post, container }) => {
    if (!!post) {
      _posts_ids.push(post)
    }
    if (!!container) {
      _containers_ids.push(container)
    }
    debouncedLoadEntities(commit)
  },

  /**
   * Get Orgstructure Post & Container extended info.
   *
   * @return Object: { containersData, postsData }
   * where containersData, postsData - arrays with extended post & container info.
   */
  entitiesInfo({ commit, getters }, { posts, containers }) {
    return new Promise((resolve, reject) => {
      // Try to find them in the Store.
      let info = null
      // TODO - use getter
      // let info = getters.info()

      if (info && info.length) {
        resolve(info)
      } else {
        let requestData = {
          posts_ids: posts || [],
          containers_ids: containers || []
        }
        apiOrg.entitiesInfo(requestData).then(response => {
          commit('addPosts', response.posts_data)
          commit('addContainers', response.containers_data)
          resolve(response)
        })
        .catch(error => {
          resolve([])
        })
      }
    })
  },

  /**
   * Get Orgstructure tree
   *
   * @return Array
   */
  tree ({ commit, state }, type) {
    return new Promise( (resolve, reject) => {
      apiOrg.tree(type).then(tree => {
        if (Array.isArray(tree)) {
          commit('setTree', tree)
          resolve(tree)
        } else {
          reject('Error occurres while loading data from server')
        }
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  
  /**
   * Ускченное дерево по доступным элементам
   * @param elements
   */
  elements({}, elements){
    return new Promise((resolve, reject) => {
      apiOrg.shortTree( elements ).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * Загрузка дерева оргструктуры
   *
   * @param {*} ctx
   * @param {*} data
   * @returns Promise
   */
  loadStructure(ctx, reload) {
    return new Promise((resolve, reject) => {
      if (!ctx.state.structure.length || reload === true) {
        apiOrg.shortTree().then(
          structure => {
            ctx.commit('setStructure', structure)
            resolve(structure)
          },
          error => {
            reject(error)
          }
        )
      } else {
        resolve(ctx.state.structure)
      }
    })
  },
  
  /**
   * Удаление компании
   * @param ctx
   * @param id
   */
  deleteCompany(ctx, id){
    return new Promise( (resolve, reject) => {
      apiOrg.deleteCompany( id ).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apps/org/store/common/org/actions.js